export const environment = {
  // apiBase: 'https://api-ticeuat.octocity.net/api/',
  production: true,
};
